// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const VulnerabilityPassIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 39 43">
    <path
      fill="url(#vulnerability-pass_svga)"
      fillRule="evenodd"
      d="m18 2.88 15.12 6V18c0 3.15-.92 6.24-2.5 9A8 8 0 0 0 23 34.92a20 20 0 0 1-5 2.23C9.8 34.78 2.88 26.62 2.88 18V8.96l15.12-6zM36 18c0 3.31-.84 6.53-2.32 9.46a8 8 0 1 1-10.11 10.5A24 24 0 0 1 18.78 40a2.6 2.6 0 0 1-1.56 0C7.7 37.18 0 28 0 18V8.96a2.8 2.8 0 0 1 1.74-2.64L16.88.22A3 3 0 0 1 18 0q.57 0 1.12.22l15.14 6.1A2.8 2.8 0 0 1 36 8.96zm-6.6 21-4-4 1.13-1.13 2.87 2.87 6.07-6.08 1.13 1.14zM27 22.17h-3v2h3a1 1 0 1 1 0 2h-3.36A6 6 0 0 1 19 29.99V19.63a1 1 0 0 0-2 0V29.9a6 6 0 0 1-4.6-3.86H9a1 1 0 0 1 0-2h3v-2H9a1 1 0 0 1 0-2h3v-2H9a1 1 0 0 1 0-2h3.4a6 6 0 0 1 2.2-2.86l-2.46-2.48a1 1 0 0 1 0-1.42 1 1 0 0 1 1.4 0l3 3.08q.72-.2 1.46-.2a6 6 0 0 1 1.5.14l3.1-3.02a1 1 0 0 1 1.7.7 1 1 0 0 1-.3.72l-2.56 2.6a6 6 0 0 1 2.2 2.86H27a1 1 0 1 1 0 2h-3v2h3a1 1 0 1 1 0 2"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="vulnerability-pass_svga"
        x1={39}
        x2={0}
        y1={22.05}
        y2={22.05}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2FC089" />
        <stop offset={1} stopColor="#6CD9AF" />
      </linearGradient>
    </defs>
  </svg>,
  "VulnerabilityPass",
);
export default VulnerabilityPassIcon;
